/* Folded-view cards (see lx-fold.css). On the collection page the row of cards nearest the middle of the
   viewport gets .is-live and shows the original packshot; it returns to the folded view when scrolled away.
   On every page, card colour rows that overflow get .is-clipped so the extra dots fade before the link. */
(function(){
  document.addEventListener('click',function(e){
    var d=e.target.closest&&e.target.closest('[data-wn-dot]');if(!d)return;
    var c=d.closest('.lxc');if(c)c.classList.add('is-picked');
  },true);

  var clipPending=false;
  function clip(){
    clipPending=false;
    document.querySelectorAll('.lxc-dots').forEach(function(d){d.classList.toggle('is-clipped',d.scrollWidth>d.clientWidth+1);});
  }
  function reqClip(){if(!clipPending){clipPending=true;requestAnimationFrame(clip);}}
  reqClip();
  addEventListener('load',reqClip);
  addEventListener('resize',reqClip,{passive:true});
  if('MutationObserver' in window)new MutationObserver(reqClip).observe(document.body,{childList:true,subtree:true});

  /* Product page offer box: live countdown that mirrors the announcement bar (date:ISO from the holiday list, midnight,
     or end of week), and shows "<Holiday> sale" when the bar is counting to a holiday. */
  [].forEach.call(document.querySelectorAll('[data-lp-cd]'),function(el){
    var src=document.querySelector('.lx-ann [data-countdown]'),mode=el.getAttribute('data-lp-cd'),name='';
    if(src){mode=src.getAttribute('data-countdown')||mode;name=src.getAttribute('data-holiday')||'';}
    var box=el.closest('[data-lp-deal]'),k=box&&box.querySelector('[data-lp-deal-k]');if(k&&name)k.textContent=name+' sale';
    function end(){var now=new Date();
      if(mode.indexOf('date:')===0){var d=new Date(mode.slice(5));if(!isNaN(d)&&d>now)return d;}
      if(mode==='midnight'){var m=new Date(now);m.setHours(24,0,0,0);return m;}
      var w=new Date(now);w.setHours(0,0,0,0);w.setDate(w.getDate()+(((8-w.getDay())%7)||7));return w;}
    var t=end(),u={};['d','h','m','s'].forEach(function(x){u[x]=el.querySelector('[data-u="'+x+'"]');});
    function pad(n){return (n<10?'0':'')+n;}
    function tick(){var ms=t-new Date();if(ms<=0){mode='week';t=end();ms=t-new Date();}
      var s=Math.floor(ms/1000),v={d:Math.floor(s/86400),h:Math.floor(s%86400/3600),m:Math.floor(s%3600/60),s:s%60};
      for(var x in u)if(u[x])u[x].textContent=x==='d'?v[x]:pad(v[x]);}
    tick();setInterval(tick,1000);
  });

  /* Product page prescription pop-up. wn-pdp.js shows/hides [data-rx-panel] when the lens choice changes; we present
     the visible panel as a modal. Closing only minimises it (.is-min), so the Rx stays selected and its fields stay in
     the form. A chip under the lens choice reopens it; Add to bag reopens it if a required field is still empty.
     The chip only reads "Prescription added" after Save with the fields filled and the confirm box ticked; closing
     any other way (or changing the Rx after saving) shows a neutral "details needed" chip. */
  [].forEach.call(document.querySelectorAll('[data-wp-rx]'),function(rx){
    var panel=rx.querySelector('[data-rx-panel]');if(!panel)return;
    panel.classList.add('rxm');panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-label','Your prescription');
    var head=document.createElement('div');head.className='rxm-head';
    head.innerHTML='<span class="rxm-eyes" aria-hidden="true"><i></i><i></i></span><div><p class="rxm-k">Prescription lenses</p><p class="rxm-t">Let’s make your lenses</p></div><button type="button" class="rxm-x" aria-label="Close">×</button>';
    panel.insertBefore(head,panel.firstChild);
    var foot=document.createElement('div');foot.className='rxm-foot';
    foot.innerHTML='<p class="rxm-err" role="alert" hidden></p><button type="button" class="rxm-save">Save prescription</button><p class="rxm-note">You can edit it any time before checkout.</p>';
    panel.appendChild(foot);
    var bg=document.createElement('div');bg.className='rxm-bg';bg.hidden=true;document.body.appendChild(bg);
    var chip=document.createElement('button');chip.type='button';chip.className='rxm-chip';chip.hidden=true;
    var saved=false,err=foot.querySelector('.rxm-err'),conf=panel.querySelector('[data-rx-confirm]'),confRow=conf&&conf.closest('label');
    function paintChip(){chip.classList.toggle('is-need',!saved);chip.innerHTML=saved?'<b aria-hidden="true">✓</b> Prescription added <span>Edit</span>':'<b aria-hidden="true">!</b> Prescription details needed <span>Add</span>';}
    function say(m){err.textContent=m||'';err.hidden=!m;}
    paintChip();
    var tabs=rx.querySelector('[role="tablist"]');(tabs||panel).insertAdjacentElement('afterend',chip);
    var lastFocus=null,lifted=[];
    /* the product column is its own stacking context (sticky), which trapped the dialog under the dimmer; flatten it while open */
    function lift(){drop();for(var el=panel.parentElement;el&&el!==document.body;el=el.parentElement){var cs=getComputedStyle(el);
      if(cs.position==='sticky'||cs.transform!=='none'||cs.filter!=='none'||cs.zIndex!=='auto'||cs.isolation==='isolate'||+cs.opacity<1||(cs.contain||'').indexOf('paint')>-1){
        lifted.push([el,el.getAttribute('style')]);el.style.setProperty('z-index','auto','important');el.style.setProperty('transform','none','important');el.style.setProperty('filter','none','important');el.style.setProperty('isolation','auto','important');el.style.setProperty('contain','none','important');el.style.setProperty('opacity','1','important');
        if(cs.position==='sticky')el.style.setProperty('position','relative','important');}}}
    function drop(){lifted.forEach(function(p){if(p[1]===null)p[0].removeAttribute('style');else p[0].setAttribute('style',p[1]);});lifted=[];}
    function shown(){return !panel.hidden;}
    function open(){if(!shown())return;panel.classList.remove('is-min');lift();bg.hidden=false;chip.hidden=true;document.documentElement.classList.add('rxm-lock');
      lastFocus=document.activeElement;var f=panel.querySelector('select,input');if(f)setTimeout(function(){f.focus({preventScroll:true});},60);}
    function close(){panel.classList.add('is-min');drop();bg.hidden=true;document.documentElement.classList.remove('rxm-lock');paintChip();say('');chip.hidden=!shown();
      if(lastFocus&&lastFocus.focus)lastFocus.focus({preventScroll:true});}
    head.querySelector('.rxm-x').addEventListener('click',close);
    foot.querySelector('.rxm-save').addEventListener('click',function(){
      var dual=panel.querySelector('[data-rx-dual]'),need=dual&&dual.checked?'[data-rx$="_sph"],[data-rx="pd_r"],[data-rx="pd_l"]':'[data-rx][required]';
      var miss=[].filter.call(panel.querySelectorAll(need),function(f){return !f.value;})[0];
      if(miss){say('Please add SPH for both eyes and your PD.');miss.classList.add('is-invalid');miss.focus();return;}
      if(conf&&!conf.checked){say('Please confirm your prescription to continue.');if(confRow){confRow.classList.add('is-need');confRow.scrollIntoView({block:'center',behavior:'smooth'});}conf.focus({preventScroll:true});return;}
      saved=true;close();});
    /* any Rx edit after saving needs a fresh Save; ticking the confirm box clears its warning */
    panel.addEventListener('change',onEdit);panel.addEventListener('input',onEdit);
    function onEdit(e){var t=e.target;if(!t.matches||!t.matches('[data-rx],[data-rx-confirm],[data-rx-dual]'))return;
      if(conf&&conf.checked){if(confRow)confRow.classList.remove('is-need');if(err.textContent.indexOf('confirm')>-1)say('');}
      if(saved){saved=false;paintChip();}}
    bg.addEventListener('click',close);
    chip.addEventListener('click',open);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&shown()&&!panel.classList.contains('is-min'))close();});
    new MutationObserver(function(){if(shown()){if(!panel.classList.contains('is-min')||!chip.hidden)open();}else{drop();bg.hidden=true;chip.hidden=true;panel.classList.remove('is-min');document.documentElement.classList.remove('rxm-lock');}})
      .observe(panel,{attributes:true,attributeFilter:['hidden']});
    rx.addEventListener('click',function(e){var t=e.target.closest&&e.target.closest('[data-rx-mode="rx"]');if(t&&shown())open();});
    var form=rx.closest('form'),addBtn=form&&form.querySelector('[data-wp-add]');
    if(addBtn)addBtn.addEventListener('click',function(){if(!shown())return;
      var missing=[].some.call(panel.querySelectorAll('[data-rx][required]'),function(f){return !f.value;});if(missing)open();},true);
    if(shown())open();
  });

  if(!document.body.classList.contains('wn-collection'))return;
  var cards=[],ticking=false;
  function collect(){cards=[].filter.call(document.querySelectorAll('main .lxc'),function(c){return c.querySelector('.lxc-fold');});}
  function upd(){
    ticking=false;
    var vh=window.innerHeight,mid=vh/2,best=null,bd=Infinity;
    var rects=cards.map(function(c){return c.getBoundingClientRect();});
    rects.forEach(function(r){
      if(!r.width||r.bottom<0||r.top>vh)return;
      var d=Math.abs((r.top+r.bottom)/2-mid);if(d<bd){bd=d;best=r;}
    });
    cards.forEach(function(c,i){var r=rects[i];c.classList.toggle('is-live',!!best&&r.width>0&&Math.abs(r.top-best.top)<8);});
  }
  function req(){if(!ticking){ticking=true;requestAnimationFrame(upd);}}
  collect();req();
  addEventListener('scroll',req,{passive:true});
  addEventListener('resize',req,{passive:true});
  var main=document.getElementById('main');
  if(main&&'MutationObserver' in window)new MutationObserver(function(){collect();req();}).observe(main,{childList:true,subtree:true});
})();

/* Product gallery: floating frosted thumbnail tray over the photo (mobile carousel). Tap a thumb to jump,
   the ring follows the swipe, and the tray rebuilds when a colour change hides/shows variant photos. */
(function(){
  var stage=document.querySelector('[data-wp-stage]'),track=stage&&stage.querySelector('[data-wp-track]');
  if(!track)return;
  var tray=document.createElement('div');tray.className='lp-thumbs';tray.setAttribute('aria-label','Photo thumbnails');
  stage.appendChild(tray);stage.classList.add('has-thumbs');
  var slides=[],btns=[],ticking=false;
  function vis(){return [].filter.call(track.querySelectorAll('.lp-slide'),function(s){return !s.hidden;});}
  function build(){
    slides=vis();tray.innerHTML='';btns=[];
    tray.hidden=slides.length<2;
    slides.forEach(function(s,i){
      var img=s.querySelector('img');if(!img)return;
      var b=document.createElement('button');b.type='button';b.className='lp-thumbs__b';
      b.setAttribute('aria-label','Photo '+(i+1)+' of '+slides.length);
      var t=document.createElement('img');t.src=img.currentSrc||img.src;t.alt='';t.loading='lazy';t.decoding='async';
      b.appendChild(t);
      b.addEventListener('click',function(){track.scrollTo({left:s.offsetLeft-track.offsetLeft,behavior:'smooth'});});
      tray.appendChild(b);btns.push(b);
    });
    mark();
  }
  function mark(){
    ticking=false;if(!btns.length)return;
    var x=track.scrollLeft+track.clientWidth/2,best=0,bd=Infinity;
    slides.forEach(function(s,i){var c=s.offsetLeft-track.offsetLeft+s.offsetWidth/2,d=Math.abs(c-x);if(d<bd){bd=d;best=i;}});
    btns.forEach(function(b,i){var on=i===best;b.classList.toggle('is-on',on);if(on)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
    var a=btns[best];if(a&&tray.scrollWidth>tray.clientWidth)tray.scrollTo({left:a.offsetLeft-(tray.clientWidth-a.offsetWidth)/2,behavior:'smooth'});
  }
  track.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(mark);}},{passive:true});
  build();
  if('MutationObserver' in window)new MutationObserver(function(){clearTimeout(build.t);build.t=setTimeout(build,60);})
    .observe(track,{attributes:true,attributeFilter:['hidden'],subtree:true,childList:true});
})();

/* Product page: put the "Buy 2 Get 1 Free" line on the first visible photo as a badge; follows colour changes. */
(function(){
  var b=document.querySelector('.lp-info .lp-b2g1'),track=document.querySelector('[data-wp-track]');
  if(!b||!track)return;
  function place(){var s=[].filter.call(track.querySelectorAll('.lp-slide'),function(x){return !x.hidden;})[0];if(s&&b.parentNode!==s)s.appendChild(b);}
  place();
  if('MutationObserver' in window)new MutationObserver(function(){clearTimeout(place.t);place.t=setTimeout(place,60);})
    .observe(track,{attributes:true,attributeFilter:['hidden'],subtree:true,childList:true});
})();